export const DEFAULT_INTERVAL = 30 * 1000;
export const MAX_PAYMENT_METHOD_REQUEST_ATTEMPTS = 3;
